
import { API, SERVICES_API } from "../config/api";

class ClientsService {

    // Consult Clients Mis ====================================================================================================

    /**
     * Consult Clients Mis
     * @type {object}
     * @property {string} cedula
     * @property {string} pasaporte
     * @property {number} canal
     * @property {number} oficina
     * @property {string} password
     * @property {number} terminal
     * @property {string} usuario
     * @returns {object} - Search result of the client info
    */
    consultarClientesMis(data) {
        const url = `/consultarClientesMis`;

        return SERVICES_API.post(url, data);
    }


    // Update Status Onboarding ====================================================================================================

    updateOnboarding(data) {
        const url = `/customerOnboardingLoginStore`;

        return API.post(url, data);
    }



    // Consult Clients File ====================================================================================================

    /**
     * Consult Clients File
     * @type {object}
     * @property {number} codigoMis
     * @returns {object} - The client file data
    */
    consultaFichaCliente(data) {
        const url = `/consultaFichaCliente`;

        return SERVICES_API.post(url, data);
    }


    // Register Client ====================================================================================================

    /**
     * Register Client
     * @type {object}
     * @property {number} canal
     * @property {number} oficina
     * @property {string} password
     * @property {string} usuario
     * @property {number} terminal
     * @property {string} actividadEconomica
     * @property {string} calificacion
     * @property {string} caracteristicaCliente
     * @property {string} cargaFamiliar
     * @property {string} catEspec
     * @property {string} cedula
     * @property {string} ciiu
     * @property {string} codMalRef
     * @property {string} codOficina
     * @property {string} codiOf
     * @property {string} codigoMis
     * @property {string} codigoSicri
     * @property {string} comentarios
     * @property {string} condicionVivienda
     * @property {string} direccion
     * @property {string} edoCivil
     * @property {string} empleado
     * @property {string} esOficinaBangente
     * @property {string} fax
     * @property {string} fechaDesde
     * @property {string} fechaNacimiento
     * @property {string} fechaUltimaModificacion
     * @property {string} fechaVenceIdentificacion
     * @property {string} fuenteOrigen
     * @property {string} grupoEconomico
     * @property {string} lenguaje
     * @property {string} lineaCredito
     * @property {string} lugarNacimiento
     * @property {string} mail
     * @property {string} nacionalidad
     * @property {string} nivelAcademico
     * @property {string} nombre
     * @property {string} nombreCompleto
     * @property {string} nombreOficial
     * @property {string} ocupacion
     * @property {string} oficina
     * @property {string} otraNacionalidad
     * @property {string} pais
     * @property {string} pasaporte
     * @property {string} patrimonioTecnico
     * @property {string} primerApellido
     * @property {string} profesion
     * @property {string} provincia
     * @property {string} referencia
     * @property {string} referenciaBancaria
     * @property {string} retiene
     * @property {string} rif
     * @property {string} riskCodPais
     * @property {string} sectorEconomico
     * @property {string} segmento
     * @property {string} segundoApellido
     * @property {string} seguridad
     * @property {string} sexo
     * @property {string} subSegmento
     * @property {string} territorio
     * @property {string} tipoCliente
     * @property {string} tipoPersona
     * @property {string} venezolano
     * @property {string} vinculacion
     * @property {string} oficinaAsesor
     * @returns {object} - True/False if the client was registered
    */
    registroClientes(data) {
        const url = `/registroClientes`;

        return SERVICES_API.post(url, data);
    }


    // Update Natural Client Details ====================================================================================================

    /**
     * Update Natural Client Details
     * @type {object}
     * @property {number} canal
     * @property {number} oficina
     * @property {string} password
     * @property {number} terminal
     * @property {number} actividadEconomica
     * @property {number} calificacion
     * @property {string} cedula
     * @property {string} ciiu
     * @property {string} codMalRef
     * @property {string} codOficina
     * @property {string} codiOf
     * @property {string} codigoMis
     * @property {string} comentarios
     * @property {string} direccion
     * @property {string} edoCivil
     * @property {string} fechaNacimiento
     * @property {string} fechaUltimaModificacion
     * @property {string} fechaVenceIdentificacion
     * @property {number} fuenteOrigen
     * @property {number} grupoEconomico
     * @property {number} lenguaje
     * @property {number} lineaCredito
     * @property {number} lugarNacimiento
     * @property {number} nacionalidad
     * @property {string} nombre
     * @property {string} nombreCompleto
     * @property {string} nombreOficial
     * @property {number} ocupacion
     * @property {number} oficina
     * @property {number} otraNacionalidad
     * @property {number} pais
     * @property {string} pasaporte
     * @property {number} patrimonioTecnico
     * @property {number} profesion
     * @property {string} primerApellido
     * @property {number} provincia
     * @property {number} referencia
     * @property {number} referenciaBancaria
     * @property {string} retiene
     * @property {string} riskCodPais
     * @property {string} sectorEconomico
     * @property {string} segmento
     * @property {string} segundoApellido
     * @property {string} seguridad
     * @property {string} sexo
     * @property {string} subSegmento
     * @property {string} territorio
     * @property {string} tipoCliente
     * @property {string} tipoPersona
     * @property {string} venezolano
     * @property {string} vinculacion
     * @returns {object} - True/False if the client was updated
    */
    actualizacionDatosClienteNatural(data) {
        const url = `/actualizacionDatosClienteNatural`;

        return SERVICES_API.post(url, data);
    }


    // Generate Client File ====================================================================================================

    /**
     * Generate Client File
     * @property {string} misCode
     * @returns {blob} - PDF of the client file
    */
    generarFichaDeCliente(misCode) {
        const url = `/fichaCliente/${misCode}/pdf`;

        return API.post(url, {}, { responseType: 'blob' });
    }


    // Generate Certificate Knowledge Contract ====================================================================================================

    /**
     * Generate Certificate Knowledge Contract
     * @property {string} misCode
     * @returns {blob} - PDF of the certificate knowledge contract
    */
    generarCertificadoConocimientoContrato(misCode) {
        const url = `/certificadoDeConocimiento/${misCode}/pdf`;

        return API.post(url, {}, { responseType: 'blob' });
    }


    // Insert Registered Client In Backoffice ====================================================================================================

    /**
     * Insert Registered Client In Backoffice 
     * @property {string} codigo_mis
     * @property {string} full_name
     * @property {string} email
     * @property {string} document
     * @property {string} type
     * @property {string} date
     * @property {string} specialCategory
     * @property {string} specialCategoryAnswer
     * @returns {object} - True/False if the client was inserted
    */
    insertarClienteEnBackoffice(data) {
        const url = `/insertarCliente`;

        return SERVICES_API.post(url, data);
    }


    // Currency Conversion ====================================================================================================

    /**
     * Currency Conversion
     * @property {string} amount
     * @property {string} currency_code
     * @returns {object} - The converted amount and currency code
    */
    currencyConversion(data) {
        const url = `/conversionMonedas`;

        return SERVICES_API.post(url, data);
    }


    // Upload Client Constancy Files ====================================================================================================

    /**
     * Upload Client Constancy Files
     * @property {string} codigoMis
     * @property {file} documentoIdentidad
     * @property {file} documentoPasaporte
     * @property {file} constanciaResidenciaRif
     * @property {file} constanciaReferenciaEconomica
     * @property {file} constanciaEstadoCuentaReferenciaEconomica
     * @property {file} constanciaReferenciaPersonal
     * @property {file} constanciaDocumentoIdentidadReferenciaPersonal
     * @property {file} constanciaDeclaracionJuradaNoCuenta
     * @property {file} constanciaEmpleo
     * @property {file} constanciaIngreso
     * @property {file} constanciaOrdenTribunal
     * @property {file} constanciaPersonaDiscapacitada
     * @property {file} constanciaAutorizacionOperarMercado
     * @property {file} constanciaCarnetLaboral
     * @property {file} constanciaCedulaRepresentanteLegal
     * @property {file} constanciaDesignacionLegalComoRepresentante
     * @property {file} constanciaNegocioPropio
     * @property {file} constanciaComplementoFatca
     * @property {file} constanciaDeclaracionJuradaDeIngresos
     * @returns {object} - True/False if the files were uploaded
    */
    subirArchivosDeConstanciaDelCliente(data) {
        const url = `/subirArchivos`;

        return API.post(url, data);
    }


    // Generate PDF of Income Declaration ====================================================================================================

    /**
     * Generate PDF of Income Declaration
     * @property {string} id
     * @returns {object} - The Url of the PDF of the income declaration
    */
    generateIncomeDeclarationPDF(id) {
        const url = `/declaracionJuradaIngresos/${id}/pdf`;

        return API.get(url, { responseType: 'blob' });
    }


}

export default new ClientsService();